import { render, staticRenderFns } from "./update-tag-warning.vue?vue&type=template&id=2f836d06&scoped=true"
import script from "./update-tag-warning.vue?vue&type=script&lang=js"
export * from "./update-tag-warning.vue?vue&type=script&lang=js"
import style0 from "./update-tag-warning.vue?vue&type=style&index=0&id=2f836d06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f836d06",
  null
  
)

export default component.exports